import PieChartCard from '../../components/admin/PieChartCard';
import TimeSeriesChart from '../../components/admin/TimeSeriesChart';
import useAdminData from './useAdminData';
import { fetchConversationsByStatus, fetchConversationsNewSeries } from '../../services/adminStatsService';

export default function AdminConversations() {
  const byStatus = useAdminData(fetchConversationsByStatus);
  const newSeries = useAdminData(fetchConversationsNewSeries, 'granularity=day');

  const pivoted = pivotByMarket(newSeries.data?.data || []);

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
      <div className="bg-white rounded-lg border border-gray-200 p-4">
        <h3 className="text-sm font-semibold text-gray-700 mb-3">By status</h3>
        {byStatus.loading ? (
          <div className="text-gray-500 text-sm">Loading…</div>
        ) : byStatus.error ? (
          <div className="text-red-600 text-sm">{byStatus.error}</div>
        ) : (
          <PieChartCard data={byStatus.data?.data || []} nameKey="status" valueKey="count" />
        )}
      </div>

      <div className="bg-white rounded-lg border border-gray-200 p-4">
        <h3 className="text-sm font-semibold text-gray-700 mb-3">New conversations per day</h3>
        {newSeries.loading ? (
          <div className="text-gray-500 text-sm">Loading…</div>
        ) : newSeries.error ? (
          <div className="text-red-600 text-sm">{newSeries.error}</div>
        ) : (
          <TimeSeriesChart
            data={pivoted.rows}
            series={pivoted.markets.map((m) => ({ key: m, label: m.toUpperCase() }))}
          />
        )}
      </div>
    </div>
  );
}

function pivotByMarket(rows) {
  const byBucket = new Map();
  const marketsSet = new Set();
  rows.forEach(({ bucket, market, count }) => {
    marketsSet.add(market);
    if (!byBucket.has(bucket)) byBucket.set(bucket, { bucket });
    byBucket.get(bucket)[market] = count;
  });
  return {
    rows: Array.from(byBucket.values()).sort((a, b) => new Date(a.bucket) - new Date(b.bucket)),
    markets: Array.from(marketsSet),
  };
}
